module.exports = __webpack_public_path__ + "img/pgaziendale-black.c9f69f19.png";